import { createFileRoute } from '@tanstack/react-router'
import { type } from 'arktype'
import { type ReactElement } from 'react'

import { UnpaidInvoicesPageSkeleton } from '#/modules/invoice/front-office/unpaid-invoices-page/unpaid-invoices-page-skeleton.tsx'
import { UnpaidInvoicesPage } from '#/modules/invoice/front-office/unpaid-invoices-page/unpaid-invoices-page.tsx'
import { frontOfficeQueryOptions } from '#/shared/front-office-query-options.ts'
import { requirePermissions } from '#/shared/routing/require-permissions.ts'

const searchSchema = type({ 'status?': "'success' | 'partialSuccess' | 'alreadyInProgress' | 'failure'" })

export const Route = createFileRoute('/(customer)/_shell/unpaid-invoices/')({
  validateSearch: searchSchema,
  beforeLoad: (options) => requirePermissions(options, ['invoice.read']),
  loaderDeps: ({ search }) => ({ status: search.status }),
  loader: ({ context, deps }) => {
    // The post-payment outcomes render from the search param alone. Loading the invoice list for them
    // would await a refetch (the payment just invalidated the query) behind a list-shaped skeleton the
    // outcome screen never renders.
    if (deps.status !== undefined) return
    return context.queryClient.ensureQueryData(
      context.trpc.invoices.getMyRecoverableInvoices.queryOptions(undefined, frontOfficeQueryOptions),
    )
  },
  pendingComponent: UnpaidInvoicesPageSkeleton,
  pendingMs: 150,
  component: UnpaidInvoicesRoute,
})

function UnpaidInvoicesRoute(): ReactElement {
  const { status } = Route.useSearch()
  return <UnpaidInvoicesPage status={status} />
}
